import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getBrowserFingerprint } from "../../libs/utils";

export const getFingerprint = createAsyncThunk(
  "fingerprint/getFingerprint",
  async (obj, { rejectWithValue }) => {
    try {
      const response = await getBrowserFingerprint();
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  data: null,
  error: null,
  status: null,
};

export const fingerprintSlice = createSlice({
  name: "fingerprint",
  initialState: initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getFingerprint.pending, (state, action) => {
        return (state = { ...state, status: "loading" });
      })
      .addCase(getFingerprint.fulfilled, (state, action) => {
        return (state = {
          ...state,
          status: "succeeded",
          data: action.payload,
          error: null,
        });
      })
      .addCase(getFingerprint.rejected, (state, action) => {
        return (state = {
          ...state,
          status: "failed",
          error: action.payload,
          data: null,
        });
      });
  },
});

export default fingerprintSlice.reducer;
